import { Container, Stack } from '@mui/material';
import React from 'react';

import { Page } from '../../../../components';
import HeaderBreadcrumbs from '../../../../components/header-breadcrumbs';
import { UserList } from '../../../../components/lists/users-list';

export const UserListScreen: React.FC = () => {
    return (
        <Page title="POM - Users">
            <Container maxWidth={false}>
                <Stack direction="row" alignItems="center" justifyContent="space-between">
                    <HeaderBreadcrumbs
                        heading="POM Users"
                        links={[
                            {
                                name: 'Manage your POM users — view activity, update details, and add or remove users.',
                                href: '/users'
                            },
                        ]}
                        activeLast={false}
                    />
                </Stack>
                <UserList />
            </Container>
        </Page>
    )
}